import React, { Component } from 'react';
import where1 from '../assets/Where1.jpeg';
import where2 from '../assets/Where2.jpeg';
import where3 from '../assets/Where3.jpeg';
import where4 from '../assets/Where4.jpeg';

import '../App.css';

class Where extends Component {
  render() {
    return (
      <div className="App">
        <div className="boxWhere">
          <div className="desc">
              <h1>Dove siamo</h1> <br />


            <div className="mapsWhere">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2792.6762643205125!2d9.116724814800927!3d45.5769484339353!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478695789021725b%3A0xda9da050bd518941!2sVia+Don+Ambrogio+Rocca%2C+3%2C+20030+Senago+MI!5e0!3m2!1sit!2sit!4v1549982082675" title="Google maps" width="60%" height="100%" />
            </div>

              <h2>Via Don Ambrogio Rocca, 3 <br />
              20030, Senago (MI) <br /><br />
              Raggiungibile in macchina: parcheggio disponibile. <br />
              Raggiungibile in pullman: fermata autobus z114 direzione Palazzolo Milanese.
              </h2>
          </div>
        </div>
        <div className="boxPhotoWhere">
          <div className="photoWhere"><img src={where2} alt="posizione di Botanica Urbana Senago" /></div>
          <div className="photoWhere"><img src={where1} alt="posizione di Botanica Urbana Senago" /></div>
          <div className="photoWhere"><img src={where4} alt="posizione di Botanica Urbana Senago" /></div>
          <div className="photoWhere"><img src={where3} alt="posizione di Botanica Urbana Senago" /></div>
        </div>
      </div>
    )
  }
}


export default Where;
